import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { LoaderProps } from './_props'
import sxs from './_styles'
import FlexBox from '../flexBox/FlexBox'

const Loader: React.FC<LoaderProps> = ({ title = 'Chargement', progressSize = '4.5rem' }) => (
    <FlexBox flexDirection="column" alignItems="center" justifyContent="center" gap="1rem" sx={sxs.container}>
        <CircularProgress size={progressSize} />
        <Typography sx={sxs.title}>{title}</Typography>
    </FlexBox>
)

export default Loader
